(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoMixtoPIIService', ReporteEvaluativoMixtoPIIService);

    ReporteEvaluativoMixtoPIIService.$inject = ['$resource'];

    function ReporteEvaluativoMixtoPIIService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteMixtoPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
					//console.log(data);
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteMixtoPII:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteMixtoPII:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteMixtoPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteMixtoPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
